import React from "react";
import { ListGroupItem, Collapse } from "reactstrap";
import FontAwesome from 'react-fontawesome';

class ListGroupCollapse extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.props.toggle(this.props.prompt);
  }

  render() {
    const prompt = this.props.prompt;
    let questions = prompt.question;

    return (
      <ListGroupItem className="faq-col  rounded-0 border-top-0 border-left-0 border-right-0">
  
        <div className="faq-container">
          <p onClick={this.toggle}>
           
            <FontAwesome
                      name='faq'
                      className='fa-caret-right faq-caret'
                      size='2x'
                    />
                     <strong className="faq-q">{questions}</strong>
          </p>
         
          <Collapse className="faq-a" isOpen={this.props.isOpen}>
            <div dangerouslySetInnerHTML={{ __html: prompt.answer }} />
          </Collapse>
          
        </div>
      </ListGroupItem>
    );
  }
}

export default ListGroupCollapse;
